<div class="right-side p-5">
  <h2>Grievance Dashboard</h2>
  <div class="section">
    <!--<div class="card mb-3">
  <div class="card-header"><h2>Grievance</h2></div>
  <div class="card-body">-->
    <!-- Event Section -->
    <!--<div class="row">
  <div class="col-md-3">
    <div class="card bg-gradient-primary box-shadow mb-2">
      <div class="card-body">
        <h5 class="card-title fs-5">Total</h5>
        <div class="d-flex align-items-center">
          <div class="fs-5">{{totalGrievances}}</div>
        </div>
        <p class="card-text mt-2">
          <button id="btnTotalGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">-->
    <!--<i class="bi bi-calendar-event ms-auto fs-4"></i>-->
    <!--<i class="bi bi-person-plus ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="card bg-gradient-success box-shadow mb-2">
      <div class="card-body">
        <h5 class="card-title fs-5">Disposed</h5>
        <div class="d-flex align-items-center">
          <div class="fs-5">{{disposedGrievances}}</div>
        </div>
        <p class="card-text mt-2">
          <button id="btnDisposedGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">-->
    <!--<i class="bi bi-calendar-check ms-auto fs-4"></i>-->
    <!--<i class="bi bi-check-circle ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="card bg-gradient-warning box-shadow mb-2">
      <div class="card-body">
        <h5 class="card-title fs-5">Pending</h5>
        <div class="d-flex align-items-center">
          <div class="fs-5">{{pendingGrievances}}</div>
        </div>
        <p class="card-text mt-2">
          <button id="btnPendingGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
            <i class="bi bi-hourglass ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="card bg-gradient-danger box-shadow mb-2">
      <div class="card-body">
        <h5 class="card-title fs-5">Rejected</h5>
        <div class="d-flex align-items-center">
          <div class="fs-5">{{rejectedGrievances}}</div>
        </div>
        <p class="card-text mt-2">
          <button id="btnRejectedGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
            <i class="bi bi-x-circle ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->


    <div class="row">
      <div class="text-end mb-2">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
        <!--<button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>-->
      </div>
      <div class="col-lg-7 col-sm-12">

        <form [formGroup]="form">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="searchControl" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>

        </form>

      </div>
    </div>
  <!--<div class="table-responsive">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th class="text-center">ID</th>
          <th class="text-center">Subject</th>
          <th class="text-center">Description</th>
          <th class="text-center">Grievance Date</th>
          <th class="text-center">Status</th>-->
      <!--<th class="text-center">Document Name</th>-->
      <!--<th class="text-center">Download</th>
        <th class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let gr of SubmittedGrievanceData ; let i = index ">
        <td>{{ gr.rowNum }}</td>
        <td class="text-center">{{ gr.msmeGrievanceId }}</td>
        <td class="text-center">{{ gr.subject }}</td>
        <td class="text-center">{{ gr.description }}</td>
        <td class="text-center">{{ gr.createdDate }}</td>
        <td class="text-center">{{ gr.status }}</td>-->
      <!--<td class="text-center">{{ gr.documentName }}</td>-->
      <!--<td class="text-center">

              <a *ngIf="gr.documentPath"
                 (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()" style="cursor: pointer" class="btn btn-warning btn-sm">
                <i class="bi bi-download"></i> Download
              </a>
            </td>
            <td class="text-center"><button class="btn btn-primary btn-sm me-2" (click)="ViewGrievance(gr.msmeGrievanceId)"> <i class="bi bi-eye"></i> View & Reply</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [disabled]="disabled"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>-->



      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="CreatedDate" matSort matSortDirection="asc" matSortDisableClear>
          <ng-container matColumnDef="Sr.No">
            <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
            <td mat-cell *matCellDef="let gr"> {{gr.rowNum}} </td>
          </ng-container>
          <ng-container matColumnDef="MSMEGrievanceId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Grievance ID</th>
            <td mat-cell *matCellDef="let gr"> {{gr.msmeGrievanceId}} </td>
          </ng-container>
          <ng-container matColumnDef="Subject">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
            <td mat-cell *matCellDef="let gr"> {{gr.subject}} </td>
          </ng-container>
          <ng-container matColumnDef="Description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
            <td mat-cell *matCellDef="let gr"> {{gr.description}} </td>
          </ng-container>
          <ng-container matColumnDef="CreatedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Grievance Date</th>
            <td mat-cell *matCellDef="let gr"> {{gr.createdDate}} </td>
          </ng-container>
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let gr"> {{gr.status}} </td>
          </ng-container>
          <ng-container matColumnDef="Download">
            <th mat-header-cell *matHeaderCellDef>Download</th>
            <td mat-cell *matCellDef="let gr">
              <a *ngIf="gr.documentPath"
                 (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()" style="cursor: pointer" class="btn btn-warning btn-sm mt-1">
                <i class="bi bi-download"></i> Download
              </a>
              <button *ngIf="gr.documentPath" class="btn btn-success btn-sm mt-1 mx-1" (click)="openFilePreviewDialog(gr.documentPath, gr.documentName)"> <i class="bi bi-file-earmark-pdf"></i> View File</button>
            </td>
          </ng-container>
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let gr"><button class="btn btn-primary btn-sm me-2" (click)="ViewGrievance(gr.msmeGrievanceId)"> <i class="bi bi-eye"></i>{{gr.status ==='Pending'? 'View & Reply':'View' }} </button></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          Row shown when there is no matching data.
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter</td>

          </tr>
        </table>

      </div>
      <mat-paginator #paginator
                     class="demo-paginator"
                     (page)="onPageChange($event)"
                     [length]="length"
                     [pageSize]="pageSize"
                     [showFirstLastButtons]="showFirstLastButtons"
                     [pageSizeOptions]="pageSizeOptions"
                     [hidePageSize]="hidePageSize"
                     [pageIndex]="pageIndex"
                     aria-label="Select page">
      </mat-paginator>


    </div>

  </div>

